import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const analyticsPluginKey = new PluginKey('analyticsPlugin');
